module.exports = __webpack_public_path__ + "img/imgTemaAnterior.10e6a06d.jpg";